export const DateSelectionType = Object.freeze({
  ALL: 0,
  TODAY: 1,
  WEEK: 2,
  MONTH: 3,
  YEAR: 4,
  RANGE: 5,
  PAST_YEAR: 6
})
